import { render } from "./EventItemSkeleton.vue?vue&type=template&id=2c6c8b25&scoped=true"
import script from "./EventItemSkeleton.vue?vue&type=script&lang=js"
export * from "./EventItemSkeleton.vue?vue&type=script&lang=js"

import "./EventItemSkeleton.vue?vue&type=style&index=0&id=2c6c8b25&scoped=true&lang=css"

import exportComponent from "/builds/vidict/ott-platform/tvapp-procricket-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6c8b25"]])

export default __exports__